import { render, staticRenderFns } from "./ProjectDocumentPage.vue?vue&type=template&id=7ce9f9c5&"
import script from "./ProjectDocumentPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectDocumentPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDocumentPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports